var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50","strokeWidth":"5","stroke":"#ffffff","fill":"none","key":0}),React.createElement("circle",{"cx":"50","cy":"50","r":"20","strokeWidth":"5","stroke":"#ffffff","strokeDasharray":"31.41592653589793 31.41592653589793","fill":"none","strokeLinecap":"round","key":1},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1s","keyTimes":"0;1","values":"0 50 50;360 50 50"}))]);
}

Loader.defaultProps = {"style":{"margin":"auto","background":"none","display":"block","shapeRendering":"auto"},"width":"200px","height":"200px","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"};

module.exports = Loader;

Loader.default = Loader;
